// extracted by mini-css-extract-plugin
export var button = "UserVerificationForm-module--button--6c9cb";
export var codeArea = "UserVerificationForm-module--codeArea--09c4b";
export var content = "UserVerificationForm-module--content--30ec3";
export var email = "UserVerificationForm-module--email--57570";
export var emailInfo = "UserVerificationForm-module--emailInfo--806e0";
export var formWrapper = "UserVerificationForm-module--formWrapper--4dc22";
export var header = "UserVerificationForm-module--header--9f8be";
export var resendLink = "UserVerificationForm-module--resendLink--685b9";
export var submitButton = "UserVerificationForm-module--submitButton--78c3f";
export var wrapper = "UserVerificationForm-module--wrapper--03de8";